import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('lp', 19, { msid: 'd119b397-8d57-4d3c-9bcb-8127dbee7a46' });

let url = wixLocation.url;

console.log("url---cons")
console.log(url)

$w.onReady(function () {
   
});



async function fireEvent(buttonName) {
    try {
        const biEventObject = {
            evid: 703,
            button_name: buttonName,
            is_valid: true,
            topic: 'wix partners site',
            url: wixLocation.url,
            Additional_info: 'Header'
        };
        await biLogger.log(biEventObject);
    } catch (error) {
        console.log(error, "sth went wrong")
    }
}

export async function partnerProgram_click(event) {
  fireEvent('Wix Marketplace')
}


export function startNowNav_click(event) {
    fireEvent('Find a Professional')
}
